export default (value) => typeof value === 'string' || value instanceof String
